import { Injectable } from '@angular/core';

import { StageService } from '../../../../../services/stage.service';
import { BaseHandler } from '../BaseHandler';
declare let THREE: any;

@Injectable()
export class WallObjectHandler extends BaseHandler {
  protected _wallSize = new THREE.Vector3();
  protected _wallDirection = new THREE.Vector3();
  protected _position = new THREE.Vector3();

  constructor(protected stageService: StageService) {
    super();
  }

  protected _calculateNewPosition(wall, wallIntersectionPoint, objectEntity) {}

  canExecute(entity) {
    return false;
  }

  getRaycastObjects(): Array<any> {
    return this.stageService.getWalls();
  }

  dragBegin(intersection) {
    return false;
  }

  dragEnd(object) {}
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectAdd/Handlers/wallHandlers.ts/WallObjectHandler.ts